const gtmAttributionData = {};

// 1. Check for clickTrackUTM items in localStorage
const utmDirect = localStorage.getItem('clickTrackUTMDirect');
const utmAssisted = localStorage.getItem('clickTrackUTMAssisted');

let utmData = null;

// 2. Use direct first, then assisted
if (utmDirect) {
  try {
    utmData = JSON.parse(utmDirect);
  } catch (e) {
    console.warn("Failed to parse clickTrackUTMDirect", e);
  }
} else if (utmAssisted) {
  try {
    utmData = JSON.parse(utmAssisted);
  } catch (e) {
    console.warn("Failed to parse clickTrackUTMAssisted", e);
  }
}

// 3. Map UTM keys if available
if (utmData) {
  gtmAttributionData['utm_source'] = utmData.source || null;
  gtmAttributionData['utm_medium'] = utmData.medium || null;
  gtmAttributionData['utm_campaign'] = utmData.campaign || null;
  gtmAttributionData['utm_term'] = utmData.term || null;
  gtmAttributionData['utm_content'] = utmData.content || null;
  gtmAttributionData['landing_page'] = utmData.landingPage || null;
  gtmAttributionData['utm_attribution_type'] = utmData.type || null;
  gtmAttributionData['event_time_stamp'] = utmData.eventTimestamp || null;
}